import PropTypes from "prop-types";
import { useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useHistory } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import useTranslate from "hooks/use-translate-language";

const SideBarItem = ({
  id,
  text,
  onClick,
  collapsable,
  items,
  selected,
  setSelected,
  onNavigate,
  position,
  totalItems
}) => {
  const [toggleItem, setToggleItem] = useState(false);
  const history = useHistory();
  const translate = useTranslate();


  return (
    <li className="side-bar-item-container">
      <ListItemButton
        className="side-bar-item"
        style={{
          fontWeight: selected == id ? "bold" : "normal",
          color: "#05294A",
          padding: "10px",
          fontFamily: "Roboto-Regular",
          marginLeft: "20px",
          marginTop: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between"
        }}
        key={id}
        id={id}
        onClick={
          collapsable
            ? () => {
                setSelected(id);
                setToggleItem(!toggleItem);
              }
            : onClick
        }
        aria-label={`${text}, ${position} of ${totalItems}`}
        aria-expanded={collapsable ? toggleItem : undefined}
        aria-haspopup={collapsable ? "menu" : undefined}
      >
        {text}
        {collapsable &&
          (toggleItem ? (
            <KeyboardArrowUpIcon
              onClick={() => {
                setToggleItem(!toggleItem);
              }}
              aria-label="hide options"
            />
          ) : (
            <KeyboardArrowDownIcon
              onClick={() => {
                setToggleItem(!toggleItem);
              }}
              aria-label="show options"
            />
          ))}
      </ListItemButton>
      <Collapse in={toggleItem}>
        <MenuList className="side-bar-it">
          {items &&
            toggleItem &&
            items.map((i, index) => (
              <MenuItem
                key={i.itemId || index}
                aria-label={i.itemText}
                sx={{ pl: 4 }}
                onClick={() => {
                  history.push(i.redirectTo);
                  if (onNavigate) {
                    onNavigate();
                  }
                }}
                id={i.itemId}
              >
                {translate(i.itemText)}
              </MenuItem>
            ))}
        </MenuList>
      </Collapse>
    </li>
  );
};

export default SideBarItem;

SideBarItem.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  collapsable: PropTypes.bool,
  items: PropTypes.array,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelected: PropTypes.func,
  onNavigate: PropTypes.func,
  position: PropTypes.number,
  totalItems: PropTypes.number
};
